// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a7cf8b29","453":"7805e220"}[chunkId] + ".chunk.js";
};